var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsBattry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3904 6.75H3.9236C2.74041 6.75 1.78125 7.70909 1.78125 8.89219V15.1078C1.78125 16.2909 2.74041 17.25 3.9236 17.25H18.3904C19.5735 17.25 20.5327 16.2909 20.5327 15.1078V8.89219C20.5327 7.70909 19.5735 6.75 18.3904 6.75Z",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3427 9.32812H4.48438C4.38082 9.32812 4.29688 9.41207 4.29688 9.51562V14.4905C4.29688 14.594 4.38082 14.678 4.48438 14.678H11.3427C11.4462 14.678 11.5302 14.594 11.5302 14.4905V9.51562C11.5302 9.41207 11.4462 9.32812 11.3427 9.32812Z",
    fill: "#9C4900",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 10.25V13.7497",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBattry);
export default __webpack_public_path__ + "static/media/Details_Battry.44d6c0ae0c3ff2549330bc4dd7fee6bd.svg";
export { ForwardRef as ReactComponent };